import script from "./TarefaView.vue?vue&type=script&setup=true&lang=js"
export * from "./TarefaView.vue?vue&type=script&setup=true&lang=js"

import "./TarefaView.vue?vue&type=style&index=0&id=dbd542a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbd542a8"]])

export default __exports__